import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import { DynamicForm } from '../../../../components/form/DynamicForm';
import { Form, Validators } from '../../../../components/form/DynamicFormTs';
import Http from '../../../../Http';
import { objectAsParams } from '../../../../helpers';
import Toast from 'react-hot-toast';
import { Button, CircularProgress } from '@material-ui/core';
import LeafletMap from '../../colonias/LeafletMap';

class Destinatario extends Component {

  state = {
    FormData: new Form([
      Form.Field('text', 'cliente_dests_nombre', '*Nombre', '', [Validators.required], 12),
      Form.Field('text', 'cliente_dests_telefono', 'Teléfono', '', [], 12),
      Form.Field('text', 'cliente_dests_domicilio', '*Domicilio', '', [Validators.required], 12),
      Form.Field('autocomplete-async-cp', 'cliente_dests_cp', '*C.P.', '', [Validators.required], 6, [], [], [], false, false, '', 'search/codigo-postal'),
      Form.Field("select", 'cliente_dests_id_colonia', '*Colonia', '', [Validators.required], 6),
      Form.Field('select', 'cliente_dests_id_localidad', 'Localidad', '', [], 6, [], [], [], false, false),
      Form.Field('text', 'cliente_dests_estado', 'Estado', '', [], 6, [], [], [], false, true),
      Form.Field('text', 'cliente_dests_ciudad', 'Ciudad', '', [], 6, [], [], [], false, true),
    ], [], 'Destinatario'),
    loading: true,
    loadingData: true,
    loadingError: '',
    id_destinatario: null,
    cliente_dests_lat: '',
    cliente_dests_lon: '',
  }


  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.loadData();
    }
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    let id = this.props.match.params.tabId;
    this.FillForm().then((f) => {
      if (id) {
        this.LoadPreds(id).then(l => {
          this.setState({ loadingData: false, loading: false });
        }).catch(() => {
          this.setState({ loadingError: 'Error al cargar (1)', loadingData: false });
        })
      } else {
        this.setState({ loading: false, loadingData: false });
      }
    }).catch(() => {
      this.setState({ loadingError: 'Error al cargar (2)', loadingData: false })
    });
  }

  FillForm = async () => {
    let id_cliente = (this.props.cliente) ? this.props.cliente : this.props.match.params.id;
    let id_destinatario = this.props.match.params.tabId;
    let params = { id_cliente, id_destinatario };
    let newForm = { ...this.state.FormData };
    try {
      const Res = await Http.get(`cliente-destinatario/form?${objectAsParams(params)}`);
      if (!Res || Res.error) { this.setState({ loadingError: 'Error al cargar el Formulario (1)' }) }
      if (Res.data.cliente_rfc_destrem && !newForm.Fields.some(f => f.Label === 'R.F.C.')) {
        newForm.Fields.push(
          Form.Section('RFC'),
          Form.Field('radio', 'cliente_dests_fm', 'Persona Fisica / Moral', '', [Validators.required], 6, [{ Label: 'Fisica', Value: "1" }, { Label: 'Moral', Value: "2" }]),
          Form.Field('text', 'cliente_dests_rfc', 'R.F.C.', '', [Validators.required], 6));
      }
      newForm.Fields = newForm.Fields.map(fi => {
        if (fi.Name === 'cliente_dests_id_colonia' && Res.data.colonias) {
          fi.Options = Res.data.colonias;
        }
        if (fi.Name === 'cliente_dests_id_localidad' && Res.data.localidades) {
          fi.Options = Res.data.localidades;
        }
        return fi;
      })
      this.setState({ FormData: newForm, showRFC: Res.data.cliente_rfc_destrem, id_destinatario });
    } catch (error) {
      this.setState({ loadingError: 'Error al cargar el Formulario (2)' })
    }
  }

  LoadPreds = async (predId = null) => {
    let { FormData, showRFC } = this.state;
    let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`cliente-destinatario/one-new/${id}`);
    if (!Res.error) {
      FormData.Fields = [
        Form.Field('text', 'cliente_dests', 'Clave', '', [Validators.required], 12, [], [], [], false, true),
        ...FormData.Fields
      ]
      FormData.Fields = FormData.Fields.map(fi => {
        if (fi.Name === 'cliente_dests_cp') {
          fi.Options = [{ Label: Res.data.cliente_dests_codigo_postal, Value: Res.data.cliente_dests_codigo_postal }]
        }
        return fi;
      })
      if (!showRFC && Res.data && Res.data.cliente_dests_rfc && !['', null, undefined].includes(Res.data.cliente_dests_rfc)) {
        let validatorrfc = null
        if (Number(Res.data.cliente_dests_fm) === 1) {
          validatorrfc = Validators.rfc_fisica;
        } else if (Number(Res.data.cliente_dests_fm) === 2) {
          validatorrfc = Validators.rfc_moral;
        } else {
          validatorrfc = Validators.rfc_fisica;
        }
        FormData.Fields.push(Form.Section('RFC'),
          Form.Field('radio', 'cliente_dests_fm', 'Persona Fisica / Moral', `${Res.data.cliente_dests_fm}`, [Validators.required], 6, [{ Label: 'Fisica', Value: "1" }, { Label: 'Moral', Value: "2" }]),
          Form.Field('text', 'cliente_dests_rfc', 'R.F.C.', '', [validatorrfc], 6));
      }
      this.setState({
        id_destinatario: Res.data.id,
        cliente_dests_lat: Res.data.cliente_dests_lat || '',
        cliente_dests_lon: Res.data.cliente_dests_lon || '',
        FormData: Form.Patch(FormData, {
          cliente_dests: Res.data.cliente_dests,
          cliente_dests_nombre: Res.data.cliente_dests_nombre,
          cliente_dests_telefono: Res.data.cliente_dests_telefono,
          cliente_dests_domicilio: Res.data.cliente_dests_domicilio,
          cliente_dests_cp: Res.data.cliente_dests_codigo_postal,
          cliente_dests_id_colonia: Res.data.cliente_dests_id_colonia,
          cliente_dests_id_localidad: Res.data.cliente_dests_id_localidad,
          cliente_dests_estado: Res.data.cliente_dests_estado,
          cliente_dests_ciudad: Res.data.cliente_dests_ciudad,
          cliente_dests_rfc: Res.data.cliente_dests_rfc,
          cliente_dests_fm: `${Res.data.cliente_dests_fm}`,
        }),
      });
      return Res.data;
    } else {
      this.setState({ loadingError: 'Error al cargar informacion(2)', loadingData: false });
    }
    return null;
  }

  onDestinatarioCpChange = (field, newForm) => {
    let destinatarioCP = field.Options.find(o => o.Value === field.Value) || {};
    let destinatario_data = {
      cliente_dests_estado: destinatarioCP.estado || '',
      cliente_dests_ciudad: destinatarioCP.ciudad || '',
      cliente_dests_id_colonia: null,
      cliente_dests_id_localidad: null,
    }
    newForm.Fields = newForm.Fields.map(f => {
      if (f.Name === 'cliente_dests_id_colonia') {
        f.Options = destinatarioCP.colonias ? destinatarioCP.colonias : [];
      } else if (f.Name === 'cliente_dests_id_localidad') {
        f.Options = destinatarioCP.localidades ? destinatarioCP.localidades : [];
      }
      return f;
    });
    newForm = Form.Patch(newForm, destinatario_data);
    return newForm;
  }

  cliFMChange = (field, newForm) => {
    let validatorrfc = null
    if (Number(field.Value) === 1) {
      validatorrfc = Validators.rfc_fisica;
    } else if (Number(field.Value) === 2) {
      validatorrfc = Validators.rfc_moral;
    }
    return Form.FieldMod(newForm, 'cliente_dests_rfc', 'Validators', [validatorrfc]);
  }

  handleMapChange = (lat, lon) => {
    this.setState({ cliente_dests_lat: lat, cliente_dests_lon: lon });
  }

  formChange = (form, field, type) => {
    let newForm = { ...form };
    if (field.Name === 'cliente_dests_cp' && type !== 'options') {
      newForm = this.onDestinatarioCpChange(field, newForm)
    } else if (field.Name === 'cliente_dests_fm' && type !== 'options') {
      newForm = this.cliFMChange(field, newForm)
    }

    this.setState({ FormData: newForm });
  }

  onSubmit = async (event) => {
    event.preventDefault();
    const { loading, id_destinatario, FormData, cliente_dests_lat, cliente_dests_lon } = this.state;
    if (loading) return;
    this.setState({ loading: true });
    let vals = {};
    let valid = Form.ValidateForm(FormData);
    if (valid !== true) {
      this.setState({ loading: false });
      return Toast.error(`Error en el campo '${valid.name}'`)
    }
    vals = Form.FieldsValues(FormData);
    vals.id_cliente = (this.props.cliente) ? this.props.cliente : this.props.match.params.id;
    vals.id_destinatario = id_destinatario;
    vals.cliente_dests_lat = cliente_dests_lat;
    vals.cliente_dests_lon = cliente_dests_lon;
    
    try {
      const url = id_destinatario ? `cliente-destinatario/edit` : `cliente-destinatario/save`;
      const Res = await Http.post(url, vals);
      if (!Res.error) {
        Toast.success(id_destinatario ? `Se actualizo el destinatario correctamente` : 'Se creo el destinatario correctamente')
        this.setState({
          loading: false, 
          sbOpen: true, 
          FormData: Form.Reset(this.state.FormData),
          id_destinatario: null,
          cliente_dests_lat: '',
          cliente_dests_lon: '',
        });
        if (this.props.onSave) {
          this.props.onSave({
            ...Res.data,
            codigo_postal: vals.cliente_dests_cp,
            estado: vals.cliente_dests_estado,
            ciudad: vals.cliente_dests_ciudad,
          });
        }
      } else {
        Toast.error(Res.errMsg)
        this.setState({ loading: false });
      } 
    } catch (error) {
      Toast.error(`Error inesperado al guardar el destinatario`)
    }
  }


  render() {
    const { FormData, loadingData, loadingError, loading, id_destinatario, cliente_dests_lat, cliente_dests_lon } = this.state;

    if (loadingData) {
      return <div style={{ width: '100%', height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }} >
        <CircularProgress size={"50px"} color="primary" />
        <div><h3>Cargando...</h3></div>
      </div>
    }

    if (loadingError) {
      return <div style={{ width: '100%', height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }} >
        <h3>{loadingError}</h3>
      </div>
    }

    return (
      <div>
        <DynamicForm
          form={FormData}
          disabled={false}
          formChange={this.formChange}
        />
        {/* <div style={{ margin: '20px 0', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '10px' }}>
          <h4 style={{ marginBottom: '10px' }}>Ubicación Geográfica del Destinatario (Arrastra el marcador para ajustar)</h4>
          <LeafletMap lat={cliente_dests_lat} lon={cliente_dests_lon} onChange={this.handleMapChange} />
        </div> */}
        <div style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'flex-end',
          marginTop: 10,
        }} >
          {this.props.onCancel && (
            <Button
              variant='contained'
              disabled={loading}
              onClick={this.props.onCancel}
              style={{ marginRight: 10 }}
              color='secondary'>
              {`Cancelar`}
            </Button>  
          )}
          <Button
            variant='contained'
            disabled={loading}
            onClick={this.onSubmit}
            color='primary'>
            {loading && <CircularProgress color="secondary" size={20} />}
            {`Guardar Destinatario ${id_destinatario ? `#${id_destinatario}` : ''} `}
          </Button>
        </div>
      </div>
    )
  }
}

export default withRouter(Destinatario)
